import React from "react";
import MovieCard from "./MovieCard";

const MovieList = (props) => {
    return (
        <div className="list">
            {
                props.movies.map((movie, i) => {
                    if (movie.vote_average === 0) {
                        movie.vote_average = "Not available"
                    }
                    return <MovieCard 
                                key={i}
                                image={"https://image.tmdb.org/t/p/w200" + movie.poster_path}
                                title={movie.title}
                                movieId={movie.id}
                                viewMovieDetails = {props.viewMovieDetails}
                            />
                })
            }
        </div>
    )
}

export default MovieList;